<ul class="layout-menu">
  <ng-container *ngFor="let item of model; let i = index">
    <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
    <li *ngIf="item.separator" class="menu-separator"></li>
  </ng-container>
</ul>

<!-- Enhanced logout button with loading state -->
<button
  (click)="triggerLogout()"
  class="layout-menu"
  [disabled]="isLogoutInProgress()"
  [title]="(isLogoutInProgress() ? 'menu.loggingOut' : 'menu.logout') | translate"
>
  <i class="pi" [ngClass]="isLogoutInProgress() ? 'pi-spin pi-spinner' : 'pi-sign-out'"></i>
  <span style="margin-left: 10px"></span>
  <span>{{ (isLogoutInProgress() ? 'menu.loggingOut' : 'menu.logout') | translate }}</span>
</button>

<!-- Optional: Emergency logout button (hidden by default, can be shown in error scenarios) -->
<button
  *ngIf="false"
  (click)="emergencyLogout()"
  class="layout-menu emergency-logout"
  title="Logout de emergencia"
>
  <i class="pi pi-exclamation-triangle"></i>
  <span style="margin-left: 10px"></span>
  <span>Logout de emergencia</span>
</button>

